import React, { useRef } from "react";
import notify from "devextreme/ui/notify";
import Form, { SimpleItem, GroupItem, Label } from "devextreme-react/form";
import "devextreme-react/text-area";
import { Format } from "devextreme-react/number-box";
import { Editing } from "devextreme-react/scheduler";
import { Button } from "devextreme-react";
import UserInfo from "../../UserInfo";
import {
  inserirOuAtualizar,
  criarTipoAlvaraConstrucaoDs,
} from "../../DataSources";
import uiInfo from "../../ui-info";
import {
  Column,
  DataGrid,
  Paging,
  Pager,
  Lookup,
} from "devextreme-react/data-grid";
import PaginaToolbar from "../../components/PaginaToolbar";
import ShowError from "../../AppServices";

const template = {
  id: undefined,
  sequencial: undefined,
  prefeituraId: undefined,
  nome: "",
  valorDaConstrucaoResidencial: undefined,
  valorDaConstrucaoResidencialMin: undefined,
  valorDaConstrucaoResidencialMax: undefined,
  valorDaConstrucaoComercial: undefined,
  valorDaConstrucaoComercialMin: undefined,
  valorDaConstrucaoComercialMax: undefined,
  valorDaConstrucaoMista: undefined,
  valorDaConstrucaoMistaMin: undefined,
  valorDaConstrucaoMistaMax: undefined,
  valorDaReformaResidencial: undefined,
  valorDaReformaResidencialMin: undefined,
  valorDaReformaResidencialMax: undefined,
  valorDaReformaComercial: undefined,
  valorDaReformaComercialMin: undefined,
  valorDaReformaComercialMax: undefined,
  valorDaReformaMista: undefined,
  valorDaReformaMistaMin: undefined,
  valorDaReformaMistaMax: undefined,
  valorDoAcrescimoResidencial: undefined,
  valorDoAcrescimoResidencialMin: undefined,
  valorDoAcrescimoResidencialMax: undefined,
  valorDoAcrescimoComercial: undefined,
  valorDoAcrescimoComercialMin: undefined,
  valorDoAcrescimoComercialMax: undefined,
  valorDoAcrescimoMista: undefined,
  valorDoAcrescimoMistaMin: undefined,
  valorDoAcrescimoMistaMax: undefined,
  valorDaDemolicaoResidencial: undefined,
  valorDaDemolicaoResidencialMin: undefined,
  valorDaDemolicaoResidencialMax: undefined,
  valorDaDemolicaoComercial: undefined,
  valorDaDemolicaoComercialMin: undefined,
  valorDaDemolicaoComercialMax: undefined,
  valorDaDemolicaoMista: undefined,
  valorDaDemolicaoMistaMin: undefined,
  valorDaDemolicaoMistaMax: undefined,
  valorTotalMin: undefined,
  valorTotalMax: undefined,
  titulo: "",
  tipoMoeda: 0,
  leiaute: "",
  classe: 1,
  unidadeBaseCalculo: undefined,
  tipoCobranca: 0,
  valorQuantidadeSimples: undefined,
  qtdeBaseCalculoMinima: undefined,
  qtdeBaseCalculoMaxima: undefined,
  qtdeUnidadesMinima: undefined,
  qtdeUnidadesMaxima: undefined,
  qtdePavimentosMinima: undefined,
  qtdePavimentosMaxima: undefined,
  enviaReceita: false,
  faixas: [],
  operacao: "0",
};

export default class TiposAlvaraConstrucaoForm extends React.Component {
  constructor(props) {
    super(props);

    this.state = { ...template, prefeituraId: UserInfo.getPrefeitura() };
    template.prefeituraId = UserInfo.getPrefeitura();
    this.taxasDs = criarTipoAlvaraConstrucaoDs();

    this.ok = this.ok.bind(this);
    this.cancel = this.cancel.bind(this);
    this.retornaFormConstrucao = this.retornaFormConstrucao.bind(this);
    this.saidaProgramada = false;
    this.onChange = this.onChange.bind(this);
    this.onValueChanged = this.onValueChanged.bind(this);
    this.onTipoCobrancaAlterado = this.onTipoCobrancaAlterado.bind(this);

    this.cobrancasOptions = {
      editorType: "dxSelectBox",
      searchEnabled: false,
      placeholder: "Selecione...",
      dataSource: [
        { id: 0, descricao: "Por Quantidade" },
        { id: 1, descricao: "Por Faixa" },
        { id: 2, descricao: "Por Valor Fixo (R$)" },
      ],
      valueExpr: "id",
      displayExpr: "descricao",
      onValueChanged: (e) => this.onTipoCobrancaAlterado(e),
    };

    this.classeAlvaraOptions = {
      editorType: "dxSelectBox",
      searchEnabled: false,
      placeholder: "Quantidade Simples",
      defaultValue: this.state.classe,
      dataSource: [
        { id: 1, descricao: "Quantidade Simples" },
        { id: 0, descricao: "Construção" },
      ],
      valueExpr: "id",
      displayExpr: "descricao",
      onValueChanged: (e) => this.onChange(e),
    };

    this.tipoFaixaOptions = {
      editorType: "dxSelectBox",
      searchEnabled: false,
      dataSource: [
        { id: 0, descricao: "Fixa" },
        { id: 1, descricao: "Variavel" },
        { id: 2, descricao: "Mista" },
      ],
      valueExpr: "id",
      displayExpr: "descricao",
    };

    this.tipoOperacoesOptions = {
      editorType: "dxSelectBox",
      searchEnabled: false,
      dataSource: [
        { id: "0", descricao: "Nova Construção" },
        { id: "1", descricao: "Reforma" },
        { id: "2", descricao: "Acrescimo" },
        { id: "3", descricao: "Demolição" },
      ],
      valueExpr: "id",
      displayExpr: "descricao",
    };

    this.moedaOpcoes = {
      searchEnabled: false,
      dataSource: [
        { id: 0, descricao: "Real" },
        { id: 1, descricao: "Unidade Fiscal" },
      ],
      valueExpr: "id",
      displayExpr: "descricao",
    };
  }

  componentDidMount() {
    if (this.props.match.params.id !== undefined) {
      this.taxasDs
        .byKey(this.props.match.params.id)
        .then((data) => {
          if (data == undefined) {
            notify("Taxa não encontrada.", "error");
            this.props.history.push("/tipos_alvara_construcao");
          }
          this.setState(data);
        })
        .catch((error) => {
          ShowError(error.response.data);
          notify(error, "error", 2000);
          this.props.history.goBack();
        });
    }

    if (this.props.match.params.id === undefined) {
      this.setState({ ...template });
    }

    if (localStorage.getItem("faixas_atuais") !== null) {
      this.setState({
        faixas: JSON.parse(localStorage.getItem("faixas_atuais")),
      });
    }
  }

  onChange(e) {
    this.setState({ classe: e.value });
  }

  onValueChanged(e) {
    this.setState({ operacao: e.value });
  }

  onTipoCobrancaAlterado(e) {
    this.setState({ tipoCobranca: e.value });
  }

  renderFaixas() {
    if (this.state.tipoCobranca === 1) {
      return (
        <PaginaToolbar titulo="Faixas">
          <DataGrid
            dataSource={this.state.faixas}
            showBorders={true}
            rowAlternationEnabled={true}
            remoteOperations={true}
            wordWrapEnabled={true}
            onInitNewRow={this.initNewRow}
          >
            <Editing
              mode={"row"}
              allowAdding={false}
              allowUpdating={true}
              allowDeleting={true}
              useIcons={true}
            />
            <Column
              dataField={"id"}
              caption={"#"}
              width={"80"}
              allowEditing={false}
              visible={false}
            />
            <Column
              dataField={"paiId"}
              caption={"Id do Fator"}
              visible={false}
            />
            <Column
              dataField={"prefeituraId"}
              caption={"Prefeitura"}
              visible={false}
            />
            <Column
              dataField={"valorInicial"}
              caption={"Valor Inicial"}
              dataType={"number"}
              format={uiInfo.formatoNumerico.n2}
              editorOptions={{ format: uiInfo.formatoNumerico.n2 }}
            />
            <Column
              dataField={"valorFinal"}
              caption={"Valor Final"}
              dataType={"number"}
              format={uiInfo.formatoNumerico.n2}
              editorOptions={{ format: uiInfo.formatoNumerico.n2 }}
            />
            <Column
              dataField={"valor"}
              caption={"Valor Fixo (R$)"}
              dataType={"number"}
              format={uiInfo.formatoNumerico.n2}
              editorOptions={{ format: uiInfo.formatoNumerico.n2 }}
            />
            <Column
              dataField={"tipoDeFaixa"}
              caption={"Tipo"}
              editorType={"dxSelectBox"}
              editorOptions={this.tipoFaixaOptions}
            >
              <Lookup
                dataSource={[
                  { id: 0, descricao: "Fixa" },
                  { id: 1, descricao: "Variavel" },
                  { id: 2, descricao: "Mista" },
                ]}
                valueExpr="id"
                displayExpr="descricao"
              />
            </Column>
            <Column
              dataField={"fracao"}
              caption={"Fração"}
              dataType={"number"}
              format={uiInfo.formatoNumerico.n2}
              editorOptions={{ format: uiInfo.formatoNumerico.n2 }}
            />
            <Column
              dataField={"variacaoFracao"}
              caption={"Vr. por Fração (R$)"}
              dataType={"number"}
              format={uiInfo.formatoNumerico.n2}
              editorOptions={{ format: uiInfo.formatoNumerico.n2 }}
            />
            <Paging defaultPageSize={uiInfo.tamanhoPaginaPadrao} />
            <Pager
              showPageSizeSelector={true}
              allowedPageSizes={uiInfo.tamanhoPaginaOpcoes}
            />
          </DataGrid>
        </PaginaToolbar>
      );
    }
  }
  render() {
    return (
      <div className={"content-block dx-card responsive-paddings"}>
        <Form formData={this.state} colCount={3}>
          <GroupItem
            caption="TIPOS DE ALVARÁ DE CONSTRUÇÃO"
            colSpan={3}
            colCount={3}
          >
            <SimpleItem dataField={"titulo"} colSpan={2}>
              <Label text="Título" />
            </SimpleItem>

            <SimpleItem
              dataField={"tipoMoeda"}
              editorType={"dxSelectBox"}
              editorOptions={this.moedaOpcoes}
            ></SimpleItem>

            <SimpleItem dataField={"leiaute"} colSpan={1}>
              <Label text="Leiaute" />
            </SimpleItem>

            <SimpleItem
              dataField={"classe"}
              editorType={"dxSelectBox"}
              editorOptions={this.classeAlvaraOptions}
            >
              <Label text="Tipo" />
            </SimpleItem>
            <SimpleItem
              dataField={"tipoCobranca"}
              editorType={"dxSelectBox"}
              editorOptions={this.cobrancasOptions}
            >
              <Label text="Tipo de Cobrança" />
            </SimpleItem>

            <SimpleItem dataField={"unidadeBaseCalculo"}>
              <Label text="Unidade de Cálculo" />
            </SimpleItem>
            <SimpleItem
              dataField={"qtdeBaseCalculoMinima"}
              editorType={"dxNumberBox"}
              editorOptions={{ format: uiInfo.formatoNumerico.n2 }}
              cssClass={"txtNumerico"}
            >
              <Label text="Quantidade Mínima" />
            </SimpleItem>
            <SimpleItem
              dataField={"qtdeBaseCalculoMaxima"}
              editorType={"dxNumberBox"}
              editorOptions={{ format: uiInfo.formatoNumerico.n2 }}
              cssClass={"txtNumerico"}
            >
              <Label text="Quantidade Máxima" />
              <Format type="fixedPoint" precision={"2"} />
            </SimpleItem>
            <SimpleItem
              dataField={"valorQuantidadeSimples"}
              editorType={"dxNumberBox"}
              editorOptions={{ format: uiInfo.formatoNumerico.n2 }}
              cssClass={"txtNumerico"}
            >
              <Label text="Valor (Fixo/Unid. Cálculo)" />
              <Format type="fixedPoint" precision={"2"} />
            </SimpleItem>
            <SimpleItem
              dataField={"qtdePavimentosMinima"}
              editorType={"dxNumberBox"}
              editorOptions={{ format: uiInfo.formatoNumerico.inteiroComPonto }}
              cssClass={"txtNumerico"}
            >
              <Label text="Pavimentos Mínimo" />
              <Format type="fixedPoint" precision={"2"} />
            </SimpleItem>
            <SimpleItem
              dataField={"qtdePavimentosMaxima"}
              editorType={"dxNumberBox"}
              editorOptions={{ format: uiInfo.formatoNumerico.inteiroComPonto }}
              cssClass={"txtNumerico"}
            >
              <Label text="Pavimentos Máximo" />
              <Format type="fixedPoint" precision={"2"} />
            </SimpleItem>

            <SimpleItem
              dataField={"qtdeUnidadesMinima"}
              editorType={"dxNumberBox"}
              editorOptions={{ format: uiInfo.formatoNumerico.inteiroComPonto }}
              cssClass={"txtNumerico"}
            >
              <Label text="Unidades Mínima" />
              <Format type="fixedPoint" precision={"2"} />
            </SimpleItem>
            <SimpleItem
              dataField={"qtdeUnidadesMaxima"}
              editorType={"dxNumberBox"}
              editorOptions={{ format: uiInfo.formatoNumerico.inteiroComPonto }}
              cssClass={"txtNumerico"}
            >
              <Label text="Unidades Máxima" />
              <Format type="fixedPoint" precision={"2"} />
            </SimpleItem>
            <SimpleItem dataField={"enviaReceita"} editorType={"dxCheckBox"}>
              <Label text="Enviar para Receita Federal" />
            </SimpleItem>
          </GroupItem>
        </Form>

        {this.renderFaixas()}

        {this.retornaFormConstrucao()}

        <br />
        <br />
        <div
          style={{
            display: "flex",
            marginTop: "25px",
            justifyContent: "center",
            alignContent: "center",
            justifyItems: "center",
            alignItems: "center",
          }}
        >
          <div style={{ display: "inline-block" }}>
            <Button
              width={120}
              text="Salvar"
              type="success"
              onClick={this.ok}
            />
          </div>
          <div style={{ marginLeft: "10px" }}>
            <Button
              width={120}
              text="Cancelar"
              type="warn"
              onClick={this.cancel}
            />
          </div>
        </div>
      </div>
    );
  }

  initNewRow(e) {
    e.data.prefeituraId = UserInfo.getPrefeitura();
  }

  ok() {
    console.log("salvando entidade");
    const entidade = { ...this.state, prefeituraId: UserInfo.getPrefeitura() };
    console.log("alvará sendo salvo", entidade);
    inserirOuAtualizar(this.taxasDs, entidade)
      .then(
        function () {
          notify("Alvará cadastrado com sucesso.", "success");
          this.props.history.goBack();
        }.bind(this)
      )
      .catch((error) => {
        ShowError(error.response.data);
        notify(error, "error", 2000);
      });
  }

  cancel() {
    localStorage.setItem("faixas_atuais", JSON.stringify(this.state.faixas));
    notify("Operação cancelada", "warning");
    this.props.history.goBack();
  }

  retornaFormConstrucao() {
    if (this.state.classe === 1) {
      return null;
    }

    return (
      <React.Fragment>
        {this.retornaFormOperacoes("0")}
        {this.retornaFormOperacoes("1")}
        {this.retornaFormOperacoes("2")}
        {this.retornaFormOperacoes("3")}
      </React.Fragment>
    );
  }

  retornaFormOperacoes(operacao) {
    if (operacao === "0") {
      return (
        <Form formData={this.state} colCount={3}>
          <GroupItem caption="Construção" colSpan={3} colCount={3}>
            <SimpleItem dataField={"valorDaConstrucaoResidencial"}>
              <Label text="Residencial (Valor M²)" />
              <Format type="fixedPoint" precision={"2"} />
            </SimpleItem>
            <SimpleItem dataField={"valorDaConstrucaoResidencialMin"}>
              <Label text="Valor M² Mínimo" />
              <Format type="fixedPoint" precision={"2"} />
            </SimpleItem>
            <SimpleItem dataField={"valorDaConstrucaoResidencialMax"}>
              <Label text="Valor M² Máximo" />
              <Format type="fixedPoint" precision={"2"} />
            </SimpleItem>

            <SimpleItem dataField={"valorDaConstrucaoComercial"}>
              <Label text="Comercial (Valor M²)" />
              <Format type="fixedPoint" precision={"2"} />
            </SimpleItem>
            <SimpleItem dataField={"valorDaConstrucaoComercialMin"}>
              <Label text="Valor M² Mínimo" />
              <Format type="fixedPoint" precision={"2"} />
            </SimpleItem>
            <SimpleItem dataField={"valorDaConstrucaoComercialMax"}>
              <Label text="Valor M² Máximo" />
              <Format type="fixedPoint" precision={"2"} />
            </SimpleItem>

            <SimpleItem dataField={"valorDaConstrucaoMista"}>
              <Label text="Mista (Valor M²)" />
              <Format type="fixedPoint" precision={"2"} />
            </SimpleItem>
            <SimpleItem dataField={"valorDaConstrucaoMistaMin"}>
              <Label text="Valor M² Mínimo" />
              <Format type="fixedPoint" precision={"2"} />
            </SimpleItem>
            <SimpleItem dataField={"valorDaConstrucaoMistaMax"}>
              <Label text="Valor M² Máximo" />
              <Format type="fixedPoint" precision={"2"} />
            </SimpleItem>
          </GroupItem>
        </Form>
      );
    }
    if (operacao === "1") {
      return (
        <Form formData={this.state} colCount={3}>
          <GroupItem caption="Reforma" colSpan={3} colCount={3}>
            <SimpleItem dataField={"valorDaReformaResidencial"}>
              <Label text="Residencial (Valor M²)" />
              <Format type="fixedPoint" precision={"2"} />
            </SimpleItem>
            <SimpleItem dataField={"valorDaReformaResidencialMin"}>
              <Label text="Valor M² Mínimo" />
              <Format type="fixedPoint" precision={"2"} />
            </SimpleItem>
            <SimpleItem dataField={"valorDaReformaResidencialMax"}>
              <Label text="Valor M² Máximo" />
              <Format type="fixedPoint" precision={"2"} />
            </SimpleItem>

            <SimpleItem dataField={"valorDaReformaComercial"}>
              <Label text="Comercial (Valor M²)" />
              <Format type="fixedPoint" precision={"2"} />
            </SimpleItem>
            <SimpleItem dataField={"valorDaReformaComercialMin"}>
              <Label text="Valor M² Mínimo" />
              <Format type="fixedPoint" precision={"2"} />
            </SimpleItem>
            <SimpleItem dataField={"valorDaReformaComercialMax"}>
              <Label text="Valor M² Máximo" />
              <Format type="fixedPoint" precision={"2"} />
            </SimpleItem>

            <SimpleItem dataField={"valorDaReformaMista"}>
              <Label text="Mista (Valor M²)" />
              <Format type="fixedPoint" precision={"2"} />
            </SimpleItem>
            <SimpleItem dataField={"valorDaReformaMistaMin"}>
              <Label text="Valor M² Mínimo" />
              <Format type="fixedPoint" precision={"2"} />
            </SimpleItem>
            <SimpleItem dataField={"valorDaReformaMistaMax"}>
              <Label text="Valor M² Máximo" />
              <Format type="fixedPoint" precision={"2"} />
            </SimpleItem>
          </GroupItem>
        </Form>
      );
    }
    if (operacao === "2") {
      return (
        <Form formData={this.state} colCount={3}>
          <GroupItem caption="Acréscimo" colSpan={3} colCount={3}>
            <SimpleItem dataField={"valorDoAcrescimoResidencial"}>
              <Label text="Residencial (Valor M²)" />
              <Format type="fixedPoint" precision={"2"} />
            </SimpleItem>
            <SimpleItem dataField={"valorDoAcrescimoResidencialMin"}>
              <Label text="Valor M² Mínimo" />
              <Format type="fixedPoint" precision={"2"} />
            </SimpleItem>
            <SimpleItem dataField={"valorDoAcrescimoResidencialMax"}>
              <Label text="Valor M² Máximo" />
              <Format type="fixedPoint" precision={"2"} />
            </SimpleItem>

            <SimpleItem dataField={"valorDoAcrescimoComercial"}>
              <Label text="Comercial (Valor M²)" />
              <Format type="fixedPoint" precision={"2"} />
            </SimpleItem>
            <SimpleItem dataField={"valorDoAcrescimoComercialMin"}>
              <Label text="Valor M² Mínimo" />
              <Format type="fixedPoint" precision={"2"} />
            </SimpleItem>
            <SimpleItem dataField={"valorDoAcrescimoComercialMax"}>
              <Label text="Valor M² Máximo" />
              <Format type="fixedPoint" precision={"2"} />
            </SimpleItem>

            <SimpleItem dataField={"valorDoAcrescimoMista"}>
              <Label text="Mista (Valor M²)" />
              <Format type="fixedPoint" precision={"2"} />
            </SimpleItem>
            <SimpleItem dataField={"valorDoAcrescimoMistaMin"}>
              <Label text="Valor M² Mínimo" />
              <Format type="fixedPoint" precision={"2"} />
            </SimpleItem>
            <SimpleItem dataField={"valorDoAcrescimoMistaMax"}>
              <Label text="Valor M² Máximo" />
              <Format type="fixedPoint" precision={"2"} />
            </SimpleItem>
          </GroupItem>
        </Form>
      );
    }
    if (operacao === "3") {
      return (
        <Form formData={this.state} colCount={3}>
          <GroupItem caption="Demolição" colSpan={3} colCount={3}>
            <SimpleItem dataField={"valorDaDemolicaoResidencial"}>
              <Label text="Residencial (Valor M²)" />
              <Format type="fixedPoint" precision={"2"} />
            </SimpleItem>
            <SimpleItem dataField={"valorDaDemolicaoResidencialMin"}>
              <Label text="Valor M² Mínimo" />
              <Format type="fixedPoint" precision={"2"} />
            </SimpleItem>
            <SimpleItem dataField={"valorDaDemolicaoResidencialMax"}>
              <Label text="Valor M² Máximo" />
              <Format type="fixedPoint" precision={"2"} />
            </SimpleItem>

            <SimpleItem dataField={"valorDaDemolicaoComercial"}>
              <Label text="Comercial (Valor M²)" />
              <Format type="fixedPoint" precision={"2"} />
            </SimpleItem>
            <SimpleItem dataField={"valorDaDemolicaoComercialMin"}>
              <Label text="Valor M² Mínimo" />
              <Format type="fixedPoint" precision={"2"} />
            </SimpleItem>
            <SimpleItem dataField={"valorDaDemolicaoComercialMax"}>
              <Label text="Valor M² Máximo" />
              <Format type="fixedPoint" precision={"2"} />
            </SimpleItem>

            <SimpleItem dataField={"valorDaDemolicaoMista"}>
              <Label text="Mista (Valor M²)" />
              <Format type="fixedPoint" precision={"2"} />
            </SimpleItem>
            <SimpleItem dataField={"valorDaDemolicaoMistaMin"}>
              <Label text="Valor M² Mínimo" />
              <Format type="fixedPoint" precision={"2"} />
            </SimpleItem>
            <SimpleItem dataField={"valorDaDemolicaoMistaMax"}>
              <Label text="Valor M² Máximo" />
              <Format type="fixedPoint" precision={"2"} />
            </SimpleItem>
          </GroupItem>
        </Form>
      );
    }
  }
}
